import React, {useEffect, useState} from 'react'
import css from '@/styles/home/homeBlockAi.module.scss'
import {observer} from "mobx-react";
import AiPluginUtil from "utils/aiPluginUtil"

function BlockAi({aiConfig}){

    return (
        <div className={css.blockAi}  >

            <div className={css.container} style={{
                backgroundImage: `url(${require('@/images/home/ai-plugin/ai智能助手.png')})`
            }}>
                <button className={css.btnToAi} onClick={() => {
                    AiPluginUtil.toAiText({aiConfig})
                }}>
                </button>

                <button className={css.btnToAiText} onClick={() => {
                    AiPluginUtil.toAiText({aiConfig})
                }}>
                </button>

                <button className={css.btnToAiScenario} onClick={() => {
                    AiPluginUtil.toAiScenario({aiConfig})
                }}>
                </button>

                <button className={css.btnToAiCreation} onClick={() => {
                    AiPluginUtil.toAiCreation({aiConfig})
                }}>
                </button>

                <button className={css.btnToAiImage} onClick={() => {
                    AiPluginUtil.toAiImage({aiConfig})
                }}>
                </button>

                <button className={css.btnToAiVideo} onClick={() => {
                    AiPluginUtil.toAiVideo({aiConfig})
                }}>
                </button>
            </div>

        </div>
    )
}

export default observer(BlockAi)